import './App.css';
import Board from "./Board"
// import { DndProvider } from 'react-dnd'
// import { HTML5Backend } from 'react-dnd-html5-backend'

function App() {
  return (
    <div className="App">r
      <Board/>
    </div>
  );
}

export default App;
